import { render, staticRenderFns } from "./RecordDot.vue?vue&type=template&id=73af1184&scoped=true&"
import script from "./RecordDot.vue?vue&type=script&lang=js&"
export * from "./RecordDot.vue?vue&type=script&lang=js&"
import style0 from "./RecordDot.vue?vue&type=style&index=0&id=73af1184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73af1184",
  null
  
)

export default component.exports